import { IconPosition, RandomIconConfig, TechIconName } from "./types";

const POSITION_RANGES = {
  "top-left": {
    top: { min: 8, max: 20 },
    left: { min: 3, max: 12 },
  },
  "top-right": {
    top: { min: 8, max: 20 },
    left: { min: 78, max: 88 },
  },
  "bottom-left": {
    top: { min: 70, max: 85 },
    left: { min: 3, max: 12 },
  },
  "bottom-right": {
    top: { min: 70, max: 85 },
    left: { min: 78, max: 88 },
  },
};

const ICON_SIZES = ["55px", "60px", "65px", "70px"];

const getRandomInRange = (min: number, max: number): number => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

const getRandomSize = (): string => {
  return ICON_SIZES[Math.floor(Math.random() * ICON_SIZES.length)];
};

export const generateIconPosition = (
  position: IconPosition,
): { top: string; left: string } => {
  const range = POSITION_RANGES[position];
  return {
    top: `${getRandomInRange(range.top.min, range.top.max)}%`,
    left: `${getRandomInRange(range.left.min, range.left.max)}%`,
  };
};

export const generateRandomIcons = (
  icons: TechIconName[],
  count: number = 3,
): RandomIconConfig[] => {
  const positions: IconPosition[] = [
    "top-left",
    "top-right",
    "bottom-left",
    "bottom-right",
  ];
  const shuffledIcons = [...icons].sort(() => Math.random() - 0.5);
  const shuffledPositions = [...positions].sort(() => Math.random() - 0.5);

  return shuffledIcons
    .slice(0, Math.min(count, icons.length))
    .map((icon, index) => ({
      icon,
      position: shuffledPositions[index % shuffledPositions.length],
      size: getRandomSize(),
    }));
};

export const generateIconAnimation = (index: number) => {
  const animations = [
    {
      rotate: [0, 5, -5, 0],
      y: [0, -20, 0],
      x: [0, -10, 0],
    },
    {
      rotate: [0, -8, 8, 0],
      y: [0, 25, 0],
      scale: [1, 1.05, 1],
    },
    {
      rotate: [0, 10, -10, 0],
      y: [0, -15, 0],
      x: [0, 8, 0],
    },
    {
      rotate: [0, -5, 5, 0],
      y: [0, 18, 0],
      scale: [1, 0.95, 1],
    },
  ];

  return animations[index % animations.length];
};

export const generateIconTransition = (index: number) => {
  const durations = [8, 9, 10, 11];
  return {
    duration: durations[index % durations.length],
    repeat: Infinity,
    ease: "easeInOut" as const,
  };
};
